import React from "react";
import PropTypes from "prop-types";
import toast from 'react-hot-toast';

const ThemeContext = React.createContext();

const ThemeProvider = ({ children }) => {
  const [themename, setthemename] = React.useState("dark");
  const toggeltheme = () => {
    themename === "light" ? setthemename("dark") : setthemename("light");
    if(themename === "dark"){
      toast('Light Mode Enabled!',
        {
          icon: '😎',
          style: {
            borderRadius: '35px',
            background: '#2978b5',
            color: '#fff',
            
          },
         position: "bottom-center"

        }
        );

    }else{
      toast('Dark Mode Enabled!',
        {
          icon: '🌜',
          style: {
            borderRadius: '35px',
            background: '#333',
            color: '#fff',
          },
         position: "bottom-center"
        }
        );
    }
  };

  return (
    <ThemeContext.Provider value={[{ themename, toggeltheme }]}>
      {children}
    </ThemeContext.Provider>
  );
};

ThemeProvider.propTypes = {
  children: PropTypes.node.isRequired
};

export { ThemeProvider, ThemeContext };
